import * as React from "react";
import { Model } from "@flowable/forms";
import styles from "./styles.css";

const deepCopy = value => JSON.parse(JSON.stringify(value));

const periodValues = [
	{ value: 1, text: "1" },
	{ value: 2, text: "2" },
	{ value: 3, text: "3" },
	{ value: 4, text: "4" },
	{ value: 5, text: "5" },
	{ value: 6, text: "6" },
	{ value: 7, text: "7" },
	{ value: 8, text: "8" },
	{ value: 9, text: "9" },
	{ value: 10, text: "10" }
];

class PeriodsDefinitionForm extends Model.StatefulFormComponent {
	state = {
		touched: true,
		formValid: true,
		loading: false,
		value: {
			numberOfPeriods: 1,
			periodRows: [ {
				periodNumber: 1,
				startDate: null,
				endDate: null,
				rateForPeriod: null,
				salaryRate: false,
				fringeRate: false,
				researchTeamSubtotal: null
			} ],
		},
		initialLoad: true
	};

	async componentDidMount () {
		if (this.props.config.value) {
			this.setState({ ...this.state, value: this.props.config.value });
		}
	}

	componentDidUpdate (prevProps, prevState, snapshot) {
	}

	shouldComponentUpdate (nextProps, nextState) {
		return nextState !== this.state;
	}

	render () {
		const { Components } = this.props;
		const { loading } = this.state;

		const disabled = this.props.config.enabled === false;
		const bem = this.bem("panel", { disabled });


		return loading ?
			(<div>Loading...</div>)
			: (
				<div className={styles.componentContainer}>
					<Components.description {...this.props}/>
					{this.renderPeriodSelection(Components)}
					{
						this.state.value?.periodRows.map((periodRow, index) =>
							this.renderPeriodRow(periodRow, index, index, bem, Components)
						)
					}
				</div>
			);
	}

	renderPeriodSelection (Components) {
		let numberOfPeriodsConfig = this.getSelectConfig("Periods", this.props.config.$path, "numberOfPeriods", this.state.value);

		return (
			<Components.select {...this.props} ckey={"numberOfPeriods"}
							   key={"numberOfPeriods"}
							   config={numberOfPeriodsConfig}
							   onChange={value => this.onNumberOfPeriodsChange(value)}
							   className={styles.select}
			/>
		);
	}

	onNumberOfPeriodsChange (newValue) {
		let newNumberOfPeriods = !newValue ? 1 : newValue;
		let oldNumberOfPeriods = this.state.value.numberOfPeriods;
		if (oldNumberOfPeriods === newNumberOfPeriods) {
			return;
		}
		let newPeriodRows = [];
		if (oldNumberOfPeriods < newNumberOfPeriods) {
			newPeriodRows = deepCopy(this.state.value.periodRows);
			for (let i = oldNumberOfPeriods; i < newNumberOfPeriods; i++) {
				newPeriodRows.push({
					periodNumber: i + 1,
					startDate: null,
					endDate: null,
					rateForPeriod: null,
					salaryRate: false,
					fringeRate: false,
					researchTeamSubtotal: null
				});
			}
		} else if (oldNumberOfPeriods > newNumberOfPeriods) {
			for (let periodRow of this.state.value.periodRows) {
				if (periodRow.periodNumber <= newNumberOfPeriods) {
					newPeriodRows.push(periodRow);
				}
			}
		}
		const value = {
			numberOfPeriods: newNumberOfPeriods,
			periodRows: newPeriodRows
		};
		this.props.onChange(value);
		this.setState({ ...this.state, value });
	}


	renderPeriodRow (periodRow, index, key, bem, Components) {
		const { config } = this.props;

		let startDateConfig = this.getDateConfig("Start Date", config.$path, index, "startDate", periodRow);
		let endDateConfig = this.getDateConfig("End Date", config.$path, index, "endDate", periodRow);
		let rateForPeriodConfig = this.getNumberConfig("F&A Rate For Period", config.$path, index, "rateForPeriod", periodRow);

		return (
			<div className={`${bem("row")} ${styles.rowContainer}`} key={`row-${index}`}>
				<Components.date {...this.props}
								 config={startDateConfig}
								 key={`${key}-startDate`}
								 ckey={`${key}-startDate`}
								 className={styles.date}
								 onChange={value => this.onPeriodRowChange(index, "startDate", value)}
				/>
				<Components.date {...this.props}
								 config={endDateConfig}
								 key={`${key}-endDate`}
								 ckey={`${key}-endDate`}
								 className={styles.date}
								 onChange={value => this.onPeriodRowChange(index, "endDate", value)}
				/>
				<Components.text {...this.props}
								 config={rateForPeriodConfig}
								 ckey={`${key}-rateForPeriod`}
								 key={`${key}-rateForPeriod`}
								 onChange={value => this.onPeriodRowChange(index, "rateForPeriod", value)}
								 className={styles.number}
				/>

			</div>
		);
	}

	onPeriodRowChange (index, field, value) {
		const newPeriodRows = deepCopy(this.state.value.periodRows);
		let parsedValue = value;
		if (field === "rateForPeriod") {
			parsedValue = PeriodsDefinitionForm.cleanUpRateForPeriodForPayload(value);
		}
		newPeriodRows[index][field] = parsedValue;
		const newValue = {
			...this.state.value,
			periodRows: newPeriodRows
		};
		this.props.onChange(newValue);
		this.setState({
			...this.state,
			value: newValue
		});
	}

	getSelectConfig (label, path, field, item) {
		let value = item != null ? item[field] : 1;

		return {
			label: label,
			type: "select",
			$errors: PeriodsDefinitionForm.validateIsRequired(value),
			value,
			enabled: true,
			extraSettings: PeriodsDefinitionForm.selectExtraSettings(periodValues)
		};
	}

	getDateConfig (label, path, index, field, item) {
		let value = item[field];

		return {
			label: label,
			$path: `${path}.${index}.${field}`,
			type: "date",
			enabled: true,
			$errors: PeriodsDefinitionForm.validateIsRequired(value),
			value: value,
			extraSettings: {
				format: "MM/DD/YYYY"
			}
		};
	}

	getNumberConfig (label, path, index, field, item) {
		const value = item[field];

		return {
			label: label,
			$path: `${path}.${index}.${field}`,
			$errors: PeriodsDefinitionForm.validateRateForPeriod(value),
			type: "text",
			value,
			enabled: true,
			validationMask: "99.99%",
			validationMaskErrorMessage: "This percent is invalid",
			extraSettings: {
			}
		};
	}

	static selectExtraSettings () {
		return {
			enableAutocomplete: true,
			dataSource: "Static",
			items: periodValues,
			storage: "Id",
			identity: "value",
			multi: false
		};
	};

	static cleanUpRateForPeriodForPayload (rateForPeriod) {
		return rateForPeriod
			?.replaceAll("_", "0")
			?.replace("%", "");
	}

	static validateRateForPeriod (value) {
		let errors = [];
		if (!this.isPresent(value)) {
			errors.push("isRequired");
		}
		if (value === "00.00") {
			errors.push("validationMask");
		}

		return errors;
	}

	static validateIsRequired (value) {
		let errors = [];
		if (!this.isPresent(value)) {
			errors.push("isRequired");
		}

		return errors;
	}

	static isPresent (value) {
		return value !== undefined && value !== null && value !== "";
	}
}

export default PeriodsDefinitionForm;

